/**
 * IndexedDB-backed offline queue for attendance & expense submissions.
 * Stores items and uploads them when the network returns.
 */
const DB_NAME = "inconti-offline";
const DB_VERSION = 1;
const STORE = "queue";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
        store.createIndex("kind", "kind", { unique: false });
        store.createIndex("created_at", "created_at", { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
  });
}

async function tx(mode = "readonly") {
  const db = await openDB();
  return db.transaction(STORE, mode).objectStore(STORE);
}

export async function enqueue(kind, payload) {
  const store = await tx("readwrite");
  return new Promise((resolve, reject) => {
    const item = { kind, payload, created_at: new Date().toISOString(), attempts: 0 };
    const req = store.add(item);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function listQueue() {
  const store = await tx();
  return new Promise((resolve, reject) => {
    const req = store.getAll();
    req.onsuccess = () => resolve(req.result || []);
    req.onerror = () => reject(req.error);
  });
}

export async function removeItem(id) {
  const store = await tx("readwrite");
  return new Promise((resolve, reject) => {
    const req = store.delete(id);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}

export async function bumpAttempts(id) {
  const store = await tx("readwrite");
  return new Promise((resolve, reject) => {
    const getReq = store.get(id);
    getReq.onsuccess = () => {
      const item = getReq.result;
      if (!item) return resolve();
      item.attempts = (item.attempts || 0) + 1;
      item.last_attempt = new Date().toISOString();
      const upd = store.put(item);
      upd.onsuccess = () => resolve();
      upd.onerror = () => reject(upd.error);
    };
    getReq.onerror = () => reject(getReq.error);
  });
}

export async function queueCount() {
  const items = await listQueue();
  return items.length;
}
